<template>
  <div
    class="divider-expand"
    @click.stop
  >
    <button
      class="button"
      type="button"
      @click.prevent="$emit('input', !value)"
    >
      <i
        class="fas"
        :class="[value ? 'fa-minus' : 'fa-plus']"
      />
      {{ label[value] }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'BtnShowAll',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    label: {
      type: Object,
      default: () => ({
        true: 'Exibir menos filtros',
        false: 'Exibir todos os filtros',
      }),
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.divider-expand {
  position: relative;
  display: flex;

  // divider
  &::before {
    content: "";

    position: absolute;
    top: 50%;
    left: 0;

    width: 100%;
    height: 1.5px;
    background-color: map.get($stone-types, "300");
  }

  .button {
    margin: 0 auto !important;

    border-radius: 17px;

    i {
      margin-right: 8px;

      font-style: normal;
      color: map.get($stone-types, "400");
    }
  }
}
</style>
